export const MARGIN_TOP = '0.5rem';
export const MARGIN_BOTTOM = '1rem';
